export default {
    Assigned : '8f9c8e02-b9ee-4f29-aeea-670cef022663',
    Stocked : '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
    Hold : '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
    PickedUp : '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
    Cancelled : '8a994741-402e-4b18-a883-60da7fc94c7b',
    Returned : '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
    Deactivated : '4f666da5-bfe0-4fb5-ad77-b92103881220',
    RemoveRx : '1708e022-a093-4cd2-a48a-eec80ded6c91',
    PICKED_UP: '40c4a4ec-b8a6-4cf9-a477-6156789b1f47',    
    Return: '9aa3323b-2625-4b8d-b46a-c0df95cd3c16',
    Ready: '21deda25-833f-48d9-b4b7-87f41593b7a0',
    Out_for_Delivery: '01d725b1-8baa-4288-9719-3152edb082d0',
    Delivered: '7c496d5a-0ab5-4987-85b9-102fd8a78d9b',
    Move: '87dee241-7922-43ce-ba9f-fc0ec4eb7830',
    Arrived: 'a830c7eb-183e-4d20-8332-72863131dc32',
    Completed: 'bfec18f7-e63e-442a-8104-3599e6590136'
  };
  


// WEBPACK FOOTER //
// ./src/components/enum/device_type.js